import { computed } from 'vue';
import useAuthStore from '../stores/auth';
import cdnAssetPath from '../functions/cdnAssetPath';

export function usePortalBranding() {
  const authStore = useAuthStore();

  const isUspaPortal = computed(() => {
    // Check localStorage first (instant, no flash)
    if (typeof window !== 'undefined' && localStorage) {
      const localPortal = localStorage.getItem('portal');
      if (localPortal) {
        return localPortal === 'uspa';
      }
    }

    // Fallback to auth store (async)
    const portal = authStore?.user?.site_settings?.portal;
    return portal === 'uspa';
  });

  const portalLogo = computed(() => {
    if (isUspaPortal.value) {
      return 'https://members.uspolo.org/images/USPA_Logo_Single.svg';
    }

    const logoFilename = authStore?.user?.site_settings?.logo_filename;
    const updatedAt = authStore?.user?.site_settings?.updated_at;

    // Convert updated_at to string if it's a number
    const version = updatedAt ? String(updatedAt) : undefined;

    // If logo_filename starts with /lms-images/, use CDN bucket path with cache busting
    if (logoFilename?.startsWith('/lms-images/')) {
      return cdnAssetPath(logoFilename, true, version);
    }

    // For traditional /img/brand_logos/ path, append cache busting if updated_at exists
    const logoPath = `/img/brand_logos/${logoFilename}`;
    if (version) {
      return `${logoPath}?v=${version}`;
    }
    return logoPath;
  });

  const portalColorScheme = computed(() => {
    if (isUspaPortal.value) {
      return {
        primary: '#13294b',
        secondary: '#a12338',
        cssClass: 'uspa-branding'
      };
    }
    return {
      primary: null,
      secondary: null,
      cssClass: 'default-branding'
    };
  });

  return {
    isUspaPortal,
    portalLogo,
    portalColorScheme
  };
}